import React from 'react';

interface CustomXAxisTickProps {
  x?: number;
  y?: number;
  payload?: {
    value: string;
  };
}

/**
 * カスタムX軸Tickコンポーネント（改行対応）
 * 日付を「日\n曜日」形式で表示
 */
export const CustomXAxisTick: React.FC<CustomXAxisTickProps> = ({ x = 0, y = 0, payload }) => {
  if (!payload?.value) return null;

  // 改行文字で分割
  const lines = payload.value.split('\n');

  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={16} textAnchor="middle" fill="#666" fontSize={16}>
        {lines.map((line, index) => (
          <tspan
            key={index}
            x={0}
            dy={index === 0 ? 14 : 16}
            fontWeight={index === 0 ? 'bold' : 'normal'}  // 日にちのみbold
          >
            {line}
          </tspan>
        ))}
      </text>
    </g>
  );
};

export default CustomXAxisTick;
